<div class="canned-service-browse">
  <div class="canned-service-browse-header">
    <div class="service-search-box flex-start-end">
      <!-- Canned Service Browse Header -->
      <div class="flex-start-center pb-0 canned-service-search">
        <div class="canned-service-search-input pb-0">
          <app-input leftIcon="fal fa-search" theme="border"
            [placeholder]="activeTabIndex === 4? 'Search codes': 'Search all services'"
            [autoFocus]="isSearchFieldFocused" id="canned-service-dialog-search" [fontSize]="12" [value]="query"
            [hasActions]="!!query?.length" (appChange)="searchCannedServices($event)" [saveIcon]="null"
            (appBlur)="isSearchFieldFocused = false" (appCancel)="_searchCannedServices('')">
          </app-input>
        </div>

        <div class="text-right">
          <i id="canned-service-dialog-close" class="fal fa-times pointer ml-4 mr-2" (click)="close(false)"></i>
        </div>
      </div>
      <!-- Canned Service Browse Header -->
    </div>
  </div>

  <div class="canned-service-browse-wrapper">
    <div class="ui-g service-tab-wrapper p-0 ">
      <div class="ui-g-12 flex-between-center p-0 browse-service-modal-header position-relative">
        <div class="flex-between-center">
          <div class="flex-start-center tab-head">
            <!-- AutoLeap -->
            <p class="service-tab internal-tab font-14 font-600 text-center m-0 pointer flex-center-center"
              [ngClass]="{ 'active': serviceType === 0 }" (click)="handleTabSelect(false)">
              <img src="assets/img/autoleap-Favicon.png" alt="autoleap-icon" class="mr-1">
              AutoLeap
            </p>

            <!-- Motor Primary -->
            <div class="icon-head" [ngClass]="{'disabled': !isMotorServicesAvailable}"></div>
            <p *ngIf="isMotorServiceEnabled"
              class="service-tab deferred-tab font-14 font-600 text-center m-0 pointer flex-center-center"
              [ngClass]="{ 'active': serviceType === 1, 'disabled': !isMotorServicesAvailable }"
              (click)="handleTabSelect(true, 1)">
              <img src="assets/img/motor-primary.svg" alt="motor-icon" class="motor-icon mr-1">
              MOTOR Primary
            </p>

            <!-- Motor Secondary -->
            <ng-container *ngIf="isMotorGen2Enabled">
              <div class="icon-head" [ngClass]="{'disabled': !isMotorGen2ServicesAvailable}"></div>
              <p class="service-tab defeicon-headrred-tab font-14 font-600 text-center m-0 pointer flex-center-center"
                [ngClass]="{ 'active': serviceType === 2, 'disabled': !isMotorGen2ServicesAvailable }"
                (click)="handleTabSelect(true,2)">
                <img src="assets/img/motor-secondary.svg" alt="motor-icon" class="motor-icon mr-1">
                MOTOR Secondary
              </p>
            </ng-container>

            <!-- Quick Service -->
            <ng-container *ngIf="isQuickServiceEnabled">
              <div class="icon-head"></div>
              <p class="service-tab defeicon-headrred-tab font-14 font-600 text-center m-0 pointer flex-center-center"
                [ngClass]="{ 'active': serviceType === 8 }" (click)="handleTabSelect(false, 8, 'quickService')">
                <img src="assets/img/lookup.svg" alt="lookup-icon" class="lookup-icon mr-1">
                Magic Services
              </p>
            </ng-container>
          </div>
        </div>

        <div class="flex-end-center mx-3">
          <button *ngIf="isMitchell1EstimatorEnabled" class="btn btn-primary mitchell1-estimator-bottom text-nowrap"
            [disabled]="!isMitchell1Connected || !vehicle?.vehicleId" (click)="handleOpenMitchell1Estimator()">
            <span class="flex-center-center"
              [pTooltip]="!vehicle?.vehicleId? 'Please add vehicle on the RO to access Mitchell1' : !isMitchell1Connected? 'Mitchell1 disconnected' : 'Import Services and parts from Mitchell1 to build RO in AutoLeap'">
              <img src="./assets/img/M1-1.svg" class="M1-1 mr-1" alt="motor">
              <span>Open Mitchell1</span>
              <i *ngIf="!isMitchell1Loading" class="far fa-external-link ml-1 font-white"></i>
              <i *ngIf="isMitchell1Loading" class="fal fa-spinner rotate ml-1"></i>
            </span>
          </button>

          <div *ngIf="vehicle?.vehicleId && !motorVehicleId && isMotorServiceEnabled"
            class="flex-end-center  mitchell1-estimator-bottom ml-3">
            <i class="fal fa-exclamation-triangle font-red font-600 pr-2"></i>

            <p class="m-0 pr-2 min-width-200">
              Vehicle <span class="font-600">{{vehicle?.name}}</span> is not linked
            </p>

            <button class="btn btn-white mr-2 text-nowrap" (click)="openVehicleInSidepanel($event, true)">
              Connect to MOTOR
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="b-top-gray-85 canned-service-tab flex-column flex-end-start">
      <div class="w-100">
        <ng-container *ngIf="serviceType === 0">
          <div class="flex-start-end flex-row service-type">
            <div class="text-center ui-g-1 pointer "
              [ngClass]="{ 'active': activeTabIndex === 0, 'font-gray-400': activeTabIndex !== 0 }"
              (click)="handleSelectTab(0)">
              <span class="font-14 font-600">Internal</span>
            </div>
            <div *ngIf="isDeferredServiceEnabled" class="text-center ui-g-1 pointer"
              [ngClass]="{ 'active': activeTabIndex === 1, 'font-gray-400': activeTabIndex !== 1 }"
              (click)="handleSelectTab(1)">
              <span class="font-14 font-600 ">Deferred</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="serviceType === 1">
          <div class="flex-start-end flex-row service-type">
            <div class="text-center ui-g-1 pointer mr-2"
              [ngClass]="{ 'active': activeTabIndex === 2, 'font-gray-400': activeTabIndex !== 2 }"
              (click)="handleSelectTab(2)">
              <span class="font-14 font-600">Services</span>
            </div>
            <div class="text-center ui-g-1 pointer mr-2"
              [ngClass]="{ 'active': activeTabIndex === 3, 'font-gray-400': activeTabIndex !== 3 }"
              (click)="handleSelectTab(3)">
              <span class="font-14 font-600 ">Maintenance</span>
            </div>
            <div class="text-center ui-g-1 pointer mr-2" *ngIf="isRepairDiagramEnabled"
              [ngClass]="{ 'active': activeTabIndex === 4, 'font-gray-400': activeTabIndex !== 4 }"
              (click)="handleSelectTab(4)">
              <span class="font-14 font-600">Code</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="activeTabIndex === 0" class="internal-service canned-service-browse-body">
    <app-internal-services [customFleetSettings]="customFleetSettings" [orderStatus]="orderStatus" [query]="query"
      [currentLang]="currentLang" [selectedInternalServices]="selectedInternalServices"
      [selectedServiceInspection]="selectedServiceInspection" [serviceTags]="serviceTags">
    </app-internal-services>
  </div>

  <div *ngIf="activeTabIndex === 1 && isDeferredServiceEnabled" class="internal-service canned-service-browse-body">
    <app-deferred-services [deferredServices]="deferredServices" [orderStatus]="orderStatus"
      [selectedInternalServices]="selectedInternalServices" [selectedServiceInspection]="selectedServiceInspection">
    </app-deferred-services>
  </div>

  <div *ngIf="activeTabIndex === 2 && isMotorServiceEnabled">
    <app-motor-service-enhanced class="ui-g motor-service canned-service-browse-body"
      [customFleetSettings]="customFleetSettings" [isRepairDiagramEnabled]="isRepairDiagramEnabled"
      [selectedMotorServices]="selectedMotorServices" [pricings]="pricings" [itemSettings]="itemSettings"
      [confirmationTitle]="confirmationTitle" [confirmationContent]="confirmationContent" [query]="query"
      [orderStatus]="orderStatus" [motorVehicle]="motorVehicle" [motorVehicleId]="motorVehicleId"
      [isMotorServiceEnabled]="isMotorServiceEnabled" [roNum]="roNum">
    </app-motor-service-enhanced>
  </div>

  <div *ngIf="activeTabIndex === 3 && isMotorServiceEnabled" class="maintainance-service canned-service-browse-body">
    <app-maintainance-services class="ui-g p-0 motor-service canned-service-browse-body"
      [customFleetSettings]="customFleetSettings" [mileage]="mileage"
      [selectedMotorServices]="selectedMaintenanceServices" [vehicle]="vehicle" [pricings]="pricings"
      [itemSettings]="itemSettings" [confirmationTitle]="confirmationTitle" [confirmationContent]="confirmationContent"
      [query]="query" [orderStatus]="orderStatus" [motorVehicle]="motorVehicle" [motorVehicleId]="motorVehicleId"
      [isMotorServiceEnabled]="isMotorServiceEnabled">
    </app-maintainance-services>
  </div>

  <div *ngIf="activeTabIndex === 4 && isMotorServiceEnabled && isRepairDiagramEnabled"
    class="code-service canned-service-browse-body">
    <app-troubleshoot-code class="ui-g p-0 motor-service canned-service-browse-body" [query]="query"
      [motorVehicle]="motorVehicle" [motorVehicleId]="motorVehicleId">
    </app-troubleshoot-code>
  </div>

  <!-- 2.0 -->
  <div *ngIf="activeTabIndex === 5 && isMotorGen2Enabled">
    <app-motor-service-enhanced-new-gen class="ui-g motor-service canned-service-browse-body"
      [customFleetSettings]="customFleetSettings" [isRepairDiagramEnabled]="isRepairDiagramEnabled"
      [selectedMotorServicesNewGen]="selectedMotorServicesNewGen" [pricings]="pricings" [itemSettings]="itemSettings"
      [confirmationTitle]="confirmationTitle" [confirmationContent]="confirmationContent" [query]="query"
      [orderStatus]="orderStatus" [motorVehicle]="motorVehicle" [motorVehicleId]="motorVehicleId" [vehicle]="vehicle"
      [isMotorServiceEnabled]="isMotorServiceEnabled">
    </app-motor-service-enhanced-new-gen>
  </div>

  <!-- quick service is almost similar  -->
  <div *ngIf="activeTabIndex === 8 && isQuickServiceEnabled" class="internal-service canned-service-browse-body">
    <app-internal-services [isPartslookupService]="'true'" [customFleetSettings]="customFleetSettings"
      [currentLang]="currentLang" [orderStatus]="orderStatus" [query]="query"
      [selectedInternalServices]="selectedInternalServices" [selectedServiceInspection]="selectedServiceInspection"
      [serviceTags]="serviceTags">
    </app-internal-services>
  </div>

  <!-- Canned Service Footer -->
  <div class="ui-g-12 canned-service-browse-footer flex-end-center p-2" *ngIf="activeTabIndex!== 4">
    <button id=" canned-service-btn-done" class="btn btn-primary btn-80 btn-12 font-14" (click)="close(true)">
      Done
    </button>
  </div>
  <!-- Canned Service Footer -->
</div>
